import React from 'react'
import { Modal } from 'react-bootstrap'
import { MapTrifold, X } from '@phosphor-icons/react'
import EventOutlinedIcon from '@mui/icons-material/EventOutlined'
import ScheduleOutlinedIcon from '@mui/icons-material/ScheduleOutlined'
import PlaceOutlinedIcon from '@mui/icons-material/PlaceOutlined'
import ActivityReportMapDetails from '../../unified/components/maps/ActivityReportMapDetails'
import { Typography } from '@mui/material'
import ShowUserReportMapModalContent from '../../map/ShowUserReportMapModalContent'
import { formatDateNoHours } from '../../../helpers/utils'
import ActivityMapMobileModalShell from '../../../components/mobile/ActivityMapMobileModalShell'

export default function GeoCardMapModal({
  show,
  handleClose,
  username,
  startDate,
  lastActivityTime,
  processedData,
  hasLoadError = false,
  onRetry,
  isMobileLayout = false
}) {
  const date = formatDateNoHours(startDate)
  const details = (
    <ActivityReportMapDetails
      clientName="Recorrido del vendedor"
      overline="Detalles del reporte de actividades"
      isMobileLayout={isMobileLayout}
      compactTypography
      items={[
        { key: 'date', icon: <EventOutlinedIcon fontSize="small" />, label: 'Fecha', value: date },
        {
          key: 'last',
          icon: <ScheduleOutlinedIcon fontSize="small" />,
          label: 'Última actividad',
          value: lastActivityTime || '—'
        },
        {
          key: 'count',
          icon: <PlaceOutlinedIcon fontSize="small" />,
          label: 'Actividades',
          value: processedData?.length || 0
        }
      ]}
    />
  )
  const content = hasLoadError ? (
    <div className="map-modal-error" role="alert">
      <div className="map-error-label">
        <p>No se pudieron cargar las actividades para mostrar el mapa.</p>
        <p>Revisa tu conexión e inténtalo nuevamente.</p>
        <button type="button" className="custom-close-button" onClick={onRetry}>
          Reintentar
        </button>
      </div>
    </div>
  ) : (
    <ShowUserReportMapModalContent data={processedData} isMobileView={isMobileLayout} />
  )
  return (
    <ActivityMapMobileModalShell
      show={show}
      onHide={handleClose}
      isMobileLayout={isMobileLayout}
      modern
      ariaLabelledBy="geofence-map-modal-title"
      desktopDialogClassName="modal-90w activity-report-modern route-tracking-modal geo-card-map-modal"
      mobileDialogClassName="geo-card-map-modal"
      mobileEyebrow="Mapa de Geocercas"
      mobileTitle={
        <Typography className="activity-map-mobile-title">
          {username || 'Vendedor'} · {date}
        </Typography>
      }
      mobileBody={
        <div className="route-mobile-content">
          {details}
          {content}
        </div>
      }
      desktopChildren={
        <>
          <Modal.Header className="no-border-bottom activity-report-modern__header">
            <div className="activity-report-modern__hero-icon">
              <MapTrifold size={27} />
            </div>
            <Modal.Title id="geofence-map-modal-title">
              <span className="activity-report-modern__title">
                Reporte: {username || 'Vendedor'}
              </span>
            </Modal.Title>
            <button
              className="activity-report-modern__close"
              type="button"
              onClick={handleClose}
              aria-label="Cerrar reporte de ubicación"
            >
              <X size={19} />
            </button>
          </Modal.Header>
          <Modal.Body className="route-modal-body">
            {details}
            {content}
          </Modal.Body>
        </>
      }
    />
  )
}
